module.exports = __webpack_public_path__ + "media/icons/sprowadzony-unactive-02a49ff2.png";